import { useNavigate } from 'react-router-dom';

import type { RBACGroup } from '../../../types';
import Autocomplete from '../../users/components/GroupAutoComplete2';

type Props = {
  roleGroups: RBACGroup[] | undefined;
  selectedId?: string;
};

// Mirrors UserSelect: pick a Role group and the selection is reflected in the URL
// (/roles/:roleId), so the page is deep-linkable like /users/:userId.
export default function RoleSelect({ roleGroups, selectedId }: Props) {
  const navigate = useNavigate();

  if (!roleGroups) {
    return <div>No roles to display</div>;
  }
  const roleList = roleGroups.filter((group) => group.displayName && group.id);

  return (
    <div>
      <div className="font-bold pb-2">Search for a Role group:</div>
      <Autocomplete
        items={roleList}
        selectedId={selectedId}
        onSelect={(group) => navigate(`/roles/${group.id}`)}
        enabled
        placeholder="Search for a Role group"
        onClear={() => navigate('/roles')}
      />
    </div>
  );
}
